// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { Outlet, useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import { LoginAppBar } from "../components/LoginAppBar";

import { useSnackbar } from "notistack";
import { RootState, useAppSelector } from "../slices/store";
import { useEffect } from "react";
import { CERT_APP_REDIRECT_URL } from "../config/constant";

const MainLayout = () => {
  const { enqueueSnackbar } = useSnackbar();
  const common = useAppSelector((state: RootState) => state.common);
  const navigate = useNavigate();

  useEffect(() => {
    if (common.timestamp != null) {
      enqueueSnackbar(common.message, {
        variant: common.type,
        preventDuplicate: true,
        anchorOrigin: { horizontal: "right", vertical: "bottom" },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [common.timestamp]);

  useEffect(() => {
    const redirectUrl = localStorage.getItem(CERT_APP_REDIRECT_URL);
    if (redirectUrl) {
      navigate(redirectUrl);
      localStorage.removeItem(CERT_APP_REDIRECT_URL);
    }
  }, []);

  return (
    <>
      <LoginAppBar />
      <div style={{ minHeight: "95vh" }}>
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default MainLayout;
